import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Anuncio from './Anuncio'

//TODO: navegacion

const TablonAnuncios = ({ nextAnuncio, previousAnuncio, indexanuncio, anuncios }) => {

    return (
        <div className="col-md-11 ml-5 responsive" style={{ minHeight: "100%" }}>

            <div className="card shadow mt-5" id="responsive-card" style={{ minHeight: "80%" }}>

                <div className="tablon-header">
                    <span className="tablon-icon">
                        <FontAwesomeIcon icon="info-circle" />
                    </span>
                    <div>
                        <h2>Tablón de anuncios</h2>
                        <p className="tablon-sub">Últimas novedades del servicio</p>
                    </div>
                </div>

                <div className="card-body pb-3">

                    {anuncios[indexanuncio]
                        ?
                        <Anuncio
                            anuncio={anuncios[indexanuncio].fields}
                        />
                        :
                        null
                    }

                    <div className="tablon-pager">
                        <span
                            className="tablon-pager-btn clickable"
                            onClick={previousAnuncio}
                            role="button"
                            aria-label="Anuncio anterior"
                        >
                            <FontAwesomeIcon icon="caret-left" style={{ fontSize: "1.3rem" }} />
                        </span>
                        {anuncios !== null
                            ?
                            <span className="tablon-pager-count">{indexanuncio + 1} / {anuncios.length}</span>
                            :
                            null
                        }
                        <span
                            className="tablon-pager-btn clickable"
                            onClick={nextAnuncio}
                            role="button"
                            aria-label="Anuncio siguiente"
                        >
                            <FontAwesomeIcon icon="caret-right" style={{ fontSize: "1.3rem" }} />
                        </span>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default TablonAnuncios
